import { useMedicationContext } from '../contexts/MedicationContext'

export const useMedications = () => {
  return useMedicationContext()
} 